import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import { DataFormatoEN } from "app/types/DataFormatoEN"
import { WindowMU } from "app/types/WindowMU"

declare var window:WindowMU

export type ConfirmarNovaDataPrevistaCapacidadeDeCargaParams = {
    identificadoresItens:number[]
    filial:string
    novaDataPrevista:DataFormatoEN
}

export async function confirmarNovaDataPrevistaCapacidadeDeCarga(params: ConfirmarNovaDataPrevistaCapacidadeDeCargaParams) {
    const orcamentoAtualizado = await microuniversoApi.Orcamento.ConfirmarNovaDataPrevisaoEntregaEncaixeItemOrcamento(
        store.getState().orcamento.IdentificadorOrcamento,
        params.identificadoresItens,
        params.novaDataPrevista,
        params.filial
    )

    window.orcamentoController.model.atualizar(orcamentoAtualizado,true,true,true)
    if (orcamentoAtualizado["Error"] != undefined) { // 485611        
        throw new Error(orcamentoAtualizado["Error"].Error || "Ocorreu um erro ao confirmar nova data prevista para capacidade de carga.")   
    }

}